import { FlagIcon, NewspaperIcon, PencilIcon, PhotographIcon, UsersIcon } from "@heroicons/react/outline";
import { Button, Chip } from "@material-tailwind/react";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import { isHaveActionPermission } from "utills/helpers";

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const WPSOrgInformationFormDetail = (props: any) => {
  const { organizationInfo, translate, isMobile } = props;

  const getLicenseName = (url: string) => {
    const position = url.lastIndexOf('/');

    const name = url.slice(position + 1);

    return name;
  }

  return (
    <div className="w-full p-[16px]">
      {
        (organizationInfo && Object.keys(organizationInfo).length > 0) &&
        <div className="w-full bg-white rounded-[8px]" id="organization-information">
          <div className="w-full h-[64px] px-[24px] flex items-center justify-between border-b border-[#d9e1e9]">
            <div className="text-16 font-600">{translate('organization-information')}</div>

            {isHaveActionPermission("info", "organization", "edit") && (
              <a href="/organization/info/edit">
                <Button
                  {...({} as any)}
                  className="h-[42px] px-[16px] rounded-[8px] border border-brand-500 bg-white flex items-center justify-center gap-x-[8px] text-16 font-600 text-brand-500"
                >
                  <PencilIcon
                    className="size-[16px] text-brand-500"
                    strokeWidth={3}
                  />
                  {!isMobile && translate("edit")}
                </Button>
              </a>
            )}

          </div>

          <div className="w-full">
            <div className="w-full h-[44px] border-b border-[#d9e1e9] px-[24px] flex items-center font-700 text-14">{translate("images-and-colors")}</div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <PhotographIcon className="size-[16px] text-[#f1600d]" />
                </div>

                <div className="box-item-title">{translate('cover-banner')}</div>

                <LightTooltip title={translate('tooltip-cover-image')} className="w-[200px]" placement='top-start'>
                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" />
                </LightTooltip>
              </div>

              <div className="flex-1">
                {
                  organizationInfo.cover_banner && organizationInfo.cover_banner !== '' ?
                    <img src={organizationInfo.cover_banner}
                      className={`${isMobile ? 'w-[176px] h-[88px] ml-[48px]' : 'w-[300px]'} object-contain`}
                      alt="icon-organization" />
                    :
                    <div className="image-default">
                      <PhotographIcon className="w-5 h-5 icon-image-default" />
                    </div>
                }

              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <PhotographIcon className="size-[16px] text-[#f1600d]" />
                </div>

                <div className="box-item-title">{translate('rectangular-promotion-banner')}</div>

                <LightTooltip title={translate('tooltip-rectangular-promotion-banner')} className="w-[200px]" placement='top-start'>
                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" />
                </LightTooltip>
              </div>

              <div className="flex-1">
                {
                  organizationInfo.rectangular_promotion_banner && organizationInfo.rectangular_promotion_banner !== '' ?
                    <img src={organizationInfo.rectangular_promotion_banner}
                      className={`${isMobile ? 'w-[176px] h-[88px] ml-[48px]' : "w-[475px] h-[150px]"}`}
                      alt="icon-organization" />
                    :
                    <div className={`${isMobile ? 'w-[176px] h-[88px] ml-[48px]' : 'w-[475px] h-[150px]'} flex items-center justify-center bg-[#F6F5FE] rounded-[8px]`}>
                      <PhotographIcon className="w-5 h-5 icon-image-default" />
                    </div>
                }

              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <PhotographIcon className="size-[16px] text-[#f1600d]" />
                </div>

                <div className="box-item-title">{translate('square-promotion-banner')}</div>

                <LightTooltip title={translate('tooltip-rectangular-promotion-banner')} className="w-[200px]" placement='top-start'>
                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" />
                </LightTooltip>
              </div>

              <div className="flex-1">
                {
                  organizationInfo.square_promotion_banner && organizationInfo.square_promotion_banner !== '' ?
                    <img src={organizationInfo.square_promotion_banner}
                      className={`${isMobile && 'ml-[48px]'} size-[100px] object-cover`}
                      alt="icon-organization" />
                    :
                    <div className={`${isMobile && 'ml-[48px]'} size-[100px] flex items-center justify-center bg-[#F6F5FE] rounded-[8px]`}>
                      <PhotographIcon className="w-5 h-5 icon-image-default" />
                    </div>
                }

              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <PhotographIcon className="size-[16px] text-[#f1600d]" />
                </div>

                <div className="box-item-title">{translate('organization-logo')}</div>

                <LightTooltip title={translate('tooltip-organization-logo')} className="w-[200px]" placement='top-start'>
                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" />
                </LightTooltip>
              </div>

              <div className="flex-1">

                {
                  organizationInfo.organization_logo && organizationInfo.organization_logo !== '' ?
                    <img src={organizationInfo.organization_logo}
                      className={`${isMobile ? 'w-[176px] h-[88px] ml-[48px]' : 'w-[300px]'} object-contain`}
                      alt="icon-organization" />
                    :
                    <div className="image-default organization-logo">
                      <PhotographIcon className="w-5 h-5 icon-image-default" />
                    </div>
                }
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <PhotographIcon className="size-[16px] text-[#f1600d]" />
                </div>

                <div className="box-item-title">{translate('organization-banner')}</div>

                <LightTooltip title={translate('tooltip-organization-banner')} className="w-[200px]">
                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" />
                </LightTooltip>
              </div>

              <div className="flex-1">

                {
                  organizationInfo.organization_banner && organizationInfo.organization_banner !== '' ?
                    <img src={organizationInfo.organization_banner}
                      className={`${isMobile ? 'w-[176px] h-[88px] ml-[48px]' : 'w-[300px]'} object-contain`}
                      alt="icon-organization" />
                    :
                    <div className="image-default">
                      <PhotographIcon className="w-5 h-5 icon-image-default" />
                    </div>
                }
              </div>


            </div>
          </div>

          <div className="w-full">
            <div className="w-full h-[44px] border-b border-[#d9e1e9] px-[24px] flex items-center font-700 text-14">{translate('information')}</div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <UsersIcon className="size-[16px] text-[#f1600d]" />
                </div>

                <div className="box-item-title">{translate('organization-name')}</div>

                <LightTooltip title={translate("tooltip-organization-name")} className="w-[200px]" placement='top-start'>
                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" />
                </LightTooltip>
              </div>

              <div className="flex-1 grid grid-cols-1 gap-[16px]">
                <div className="w-full">
                  <Chip value="Vietnam" className="w-[77px] mb-[8px] bg-[#e9ecff] text-[#262626]" />

                  <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>
                    {organizationInfo.name.vi}
                  </div>
                </div>

                <div className="w-full">
                  <Chip value="English" className="w-[77px] mb-[8px] bg-[#e9ecff] text-[#262626]" />

                  <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>
                    {organizationInfo.name.en}
                  </div>
                </div>
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <FlagIcon className="size-[16px] text-[#f1600d]" />
                </div>

                <div className="box-item-title">{translate('country')}</div>
              </div>

              <div className="flex-1">
                <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>{organizationInfo.country}</div>
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <NewspaperIcon className="size-[16px] text-[#f1600d]" />
                </div>

                <div className="box-item-title">{translate('organization-introduction')}</div>

                <LightTooltip title={translate("tooltip-organization-introduction")} className="w-[200px]" placement='top-start'>
                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" />
                </LightTooltip>
              </div>

              <div className="flex-1 grid grid-cols-1 gap-[16px]">
                <div className="w-full">
                  <Chip value="Vietnam" className="w-[77px] bg-[#e9ecff] text-14 text-[#262626] mb-[8px]" />

                  <div className="box-content" dangerouslySetInnerHTML={{
                    __html: organizationInfo.introduction.vi,
                  }}>
                  </div>
                </div>

                <div className="w-full">
                  <Chip value="English" className="w-[77px] bg-[#e9ecff] text-14 text-[#262626] mb-[8px]" />

                  <div className="box-content" dangerouslySetInnerHTML={{
                    __html: organizationInfo.introduction.en,
                  }}>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full">
            <div className="w-full h-[44px] border-b border-[#d9e1e9] px-[24px] flex items-center font-700 text-14">
              <span className='mr-[10px]'>{translate('seller-identification')}</span>

              <LightTooltip title={translate("tooltip-seller-identification")} className="w-[200px]" placement='top-start'>
                <img src="/images/icons/tooltip.svg" alt="icon-tooltip" />
              </LightTooltip>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <img src='/images/icons/icon-company-name.svg' alt='icon-company-name' />
                </div>

                <div className="box-item-title">{translate('company-name')}</div>
              </div>

              <div className="flex-1">
                <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>{organizationInfo.seller_company_name}</div>
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <img src='/images/icons/icon-company-tax.svg' alt='icon-company-tax' />
                </div>

                <div className="box-item-title">{translate('company-tax-id')}</div>
              </div>

              <div className="flex-1">
                <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>{organizationInfo.seller_company_tax}</div>
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <img src='/images/icons/icon-company-license.svg' alt='icon-company-license' />
                </div>

                <div className="box-item-title">{translate('company-license')}</div>
              </div>

              {
                (organizationInfo.seller_business_license && organizationInfo.seller_business_license.length > 0) &&
                <div className="flex-1 grid grid-cols-1 gap-y-[8px]">
                  {/* <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>{organizationInfo.seller_business_license}</div> */}
                  {
                    organizationInfo.seller_business_license.map((license: string, index: number) => {
                      return (
                        <a href={license} target='_blank' key={`license_name_${index}`} className={`${isMobile && 'ml-[48px]'} text-14 text-[#011BB6] underline`}>{getLicenseName(license)}</a>
                      )
                    })
                  }
                </div>
              }

            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <img src='/images/icons/icon-company-certificate.svg' alt='icon-company-certificate' />
                </div>

                <div className="box-item-title">{translate('company-certificate')}</div>
              </div>

              <div className="flex-1">
                <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>{organizationInfo.seller_business_certificate_number}</div>
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <img src='/images/icons/icon-company-issue-date.svg' alt='icon-company-issue-date' />
                </div>

                <div className="box-item-title">{translate('company-issue-date')}</div>
              </div>

              <div className="flex-1">
                <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>{moment(organizationInfo.seller_business_issue_date).format('DD/MM/YYYY')}</div>
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <img src='/images/icons/icon-company-name.svg' alt='icon-company-name' />
                </div>

                <div className="box-item-title">{translate('company-place-of-issue')}</div>
              </div>

              <div className="flex-1">
                <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>{organizationInfo.seller_place_of_issue}</div>
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <img src='/images/icons/icon-company-name.svg' alt='icon-company-name' />
                </div>

                <div className="box-item-title">{translate('company-business-address')}</div>
              </div>

              <div className="flex-1">
                <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>{organizationInfo.seller_business_address}</div>
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <img src='/images/icons/icon-company-email.svg' alt='icon-company-email' />
                </div>

                <div className="box-item-title">Email</div>
              </div>

              <div className="flex-1">
                <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>{organizationInfo.seller_company_email}</div>
              </div>
            </div>

            <div className={`${isMobile ? 'grid grid-cols-1 gap-[8px]' : 'flex items-center justify-center gap-x-[50px]'} w-full px-[24px] py-[16px] border-b border-[#d9e1e9]`}>
              <div className="w-[300px] flex items-center gap-x-[8px]">
                <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                  <img src='/images/icons/icon-company-phone.svg' alt='icon-company-phone' />
                </div>

                <div className="box-item-title">{translate('phone')}</div>
              </div>

              <div className="flex-1">
                <div className={`${isMobile && 'ml-[48px]'} text-14 text-[#2b3033]`}>(+{organizationInfo.seller_company_phone_area_code}) {organizationInfo.seller_company_phone}</div>
              </div>
            </div>
          </div>

        </div>
      }

    </div>
  )
};

export default WPSOrgInformationFormDetail;